import { DateTime } from 'luxon';

export default function cloneDateTime(dateTime) {
    return DateTime.fromMillis(dateTime.toMillis(), { zone: 'UTC' });
}
